export default {
  creatingUser: 'Criando usuário {name}...',
  title: 'Usuários',
  createUser: 'Criar Usuário',
  warningTitle: 'Aviso',
  deleteConfirmation: 'Excluindo usuário: {name}',
  deleteWarning: 'Esta ação não pode ser desfeita. Tem certeza?',
  cancel: 'Cancelar',
  delete: 'Excluir',
  editUser: 'Editar Usuário',
  deleteUser: 'Excluir Usuário',
  deleting: 'Excluindo...',
  headerFirstName: 'Nome',
  headerLastName: 'Sobrenome',
  headerEmail: 'E-mail',
  headerAdmin: 'Admin',
  headerManager: 'Gerente',
  headerScientist: 'Cientista',
  headerSupervisor: 'Supervisor',
  headerCustomizer: 'Personalizador',
  headerDomain: 'Domínio',
  headerCreated: 'Criado',
  headerActions: 'Ações'
}
